<template>
  <div class="preloader">
    <div class="wrapper" :class="isWrapperCenter ? 'wrapper-center' : ''">
      <div class="loader-circle">
        <span class="circle circle-1"></span>
        <span class="circle circle-2"></span>
        <span class="circle circle-3"></span>
        <span class="circle circle-4"></span>
        <span class="circle circle-5"></span>
        <span class="circle circle-6"></span>
        <span class="circle circle-7"></span>
        <span class="circle circle-8"></span>
      </div>
    </div>
  </div>
</template>

 <script>
 import {getterTypes} from "@/store/modules/auth";

 export default {
   name: 'DashboardPreloader',
   data(){
     return {
       isWrapperCenter: null
     }
   },
   computed: {
     currentUser() {
       return this.$store.getters[getterTypes.currentUser]
     },
     isLoggedIn() {
       return this.$store.getters[getterTypes.isLoggedIn]
     }
   }
 }
 </script>

<style lang="scss" scoped>
  @import "@/scss/variables.scss";
  .wrapper{
    position:absolute;
    top:50%;
    left:50%;
    transform:translate(-50%, -50%);
  }
  .wrapper-center{
    left:50%;
    transform:translate(-50%, -50%);
  }
  .circle{
    display: inline-block;
    width: 15px;
    height: 15px;
    background-color: $loader-dg-0;
    border-radius: 50%;
    animation: loading 1.5s cubic-bezier(.8, .5, .2, 1.4) infinite;
    transform-origin: bottom center;
    position: relative;
  }
  @keyframes loading{
    0%{
      transform: translateY(0px);
      background-color: $loader-dg-0;
    }
    50%{
      transform: translateY(50px);
      background-color: $loader-dg-50;
    }
    100%{
      transform: translateY(0px);
      background-color: $loader-dg-100;
    }
  }
  .circle-1{
    animation-delay: 0.1s;
  }
  .circle-2{
    animation-delay: 0.2s;
  }
  .circle-3{
    animation-delay: 0.3s;
  }
  .circle-4{
    animation-delay: 0.4s;
  }
  .circle-5{
    animation-delay: 0.5s;
  }
  .circle-6{
    animation-delay: 0.6s;
  }
  .circle-7{
    animation-delay: 0.7s;
  }
  .circle-8{
    animation-delay: 0.8s;
  }
</style>